import React from 'react'
import Head from 'next/head'
import Pitch from './Pitch'
import JobTypes from './JobTypes'
import WhyWorkWithUs from './WhyWorkWithUs'
import WarriorTestimonial from './WarriorTestimonial'
import HowItWorks from './HowItWorks'
import ProviderFeatures from './ProviderFeatures'
import GrowthHub from './GrowthHub'
import BottomCTA from '../common/components/BottomCTA'

function ProviderPortal() {
  return (
    <>
      <Head>
        <title>
          Providers - Start Growing Your Business Today | Dimension Waste Management
        </title>
        <meta name="description" content="Dimension makes it simple for anyone with a hauling or dumpster rental business to connect to hundreds of jobs nearby, all with just the click of a button." />
        <meta name='viewport' content='width=device-width, initial-scale=1' />
      </Head>
      <Pitch />
      <JobTypes />
      <WhyWorkWithUs />
      <WarriorTestimonial />
      <HowItWorks />
      <ProviderFeatures />
      <GrowthHub />
      <BottomCTA isProviderPortal />
    </>
  )
}

export default ProviderPortal
